/* hs-eslint ignored failing-rules */

import { useEffect } from 'react';
import { useMutation, useQuery } from 'data-fetching-client';
import { useLocation } from 'react-router-dom';
import getIn from 'immutable-less/transmute/getIn';
import { parseLocation } from 'automation-ui-routing/utils';
import { AutomationPlatformFlowProperties } from 'automation-ui-management/constants/CrmWorkflowProperties';
import { UPDATE_FLOW_CRM_OBJECT, UPDATE_FLOW, GET_FLOW_BY_ID, FLOW_CRM_OBJECT_BY_ID_FIELDNAME, FLOW_BY_ID_FIELDNAME } from 'automation-ui-management/queries/flowQueries';
import { CRM_OBJECT_SEARCH_FIELD_NAME, CRM_OBJECT_SEARCH_BY_FLOW_ID } from 'automation-ui-management/queries/crmObjectQueries';
import { reportError } from 'automation-ui-core/errors/utils/reportError';
export const useGetNameAndDescription = ({
  flowId,
  flowFromProps
}) => {
  const getCrmObjectResult = useQuery(CRM_OBJECT_SEARCH_BY_FLOW_ID, {
    variables: {
      flowId: String(flowId)
    }
  });
  const getFlowQueryResult = useQuery(GET_FLOW_BY_ID, {
    variables: {
      flowId
    }
  });
  const flow = getFlowQueryResult.data && getFlowQueryResult.data[FLOW_BY_ID_FIELDNAME];
  const description = getIn(['data', CRM_OBJECT_SEARCH_FIELD_NAME, 'properties', AutomationPlatformFlowProperties.DESCRIPTION, 'value'], getCrmObjectResult) || '';
  const location = useLocation();
  const hasDescriptionToCloneOrRestore = parseLocation(location).hasDescription === 'true';
  const shouldPollForDescription = Boolean(hasDescriptionToCloneOrRestore && !description);
  useEffect(() => {
    if (shouldPollForDescription) {
      getCrmObjectResult.startPolling(1000);
    }
    return () => {
      getCrmObjectResult.stopPolling();
    };
  }, [shouldPollForDescription, getCrmObjectResult]);
  useEffect(() => {
    // DEV NOTE: If used by an app where the flow object can be updated,
    // we need to refetch the flow object to have the most updated flow
    // otherwise the call to update will fail due to being out of date
    if (flowFromProps && flow) {
      if (flowFromProps.updateMetadata.updatedAt !== flow.updateMetadata.updatedAt) getFlowQueryResult.refetch({
        flowId
      }).catch(error => {
        reportError({
          error
        });
      });
    }
    // not necessary to run this effect when flow changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [flowFromProps, getFlowQueryResult, flowId]);
  return {
    flow,
    description,
    getCrmObjectResult,
    getFlowQueryResult,
    shouldPollForDescription
  };
};
export const useUpdateNameAndDescription = ({
  flowId,
  onDescriptionSaveSuccess,
  onNameSaveSuccess
}) => {
  const [updateCrmObject, updateCrmObjectQueryResult] = useMutation(UPDATE_FLOW_CRM_OBJECT, {
    onCompleted: crmObjectResponse => {
      if (onDescriptionSaveSuccess) {
        const descriptionFromCrmObject = getIn([FLOW_CRM_OBJECT_BY_ID_FIELDNAME, 'properties', 'hs_description', 'value'], crmObjectResponse);
        onDescriptionSaveSuccess(descriptionFromCrmObject);
      }
    },
    refetchQueries: [{
      query: CRM_OBJECT_SEARCH_BY_FLOW_ID,
      variables: {
        flowId: String(flowId)
      }
    }]
  });
  const [updateFlow, updateFlowQueryResult] = useMutation(UPDATE_FLOW, {
    onCompleted: updateFlowResponse => {
      if (onNameSaveSuccess) {
        const updatedFlow = updateFlowResponse[FLOW_BY_ID_FIELDNAME];
        onNameSaveSuccess(updatedFlow);
      }
    },
    refetchQueries: [{
      query: GET_FLOW_BY_ID,
      variables: {
        flowId
      }
    }]
  });
  return {
    updateCrmObject,
    updateCrmObjectQueryResult,
    updateFlow,
    updateFlowQueryResult
  };
};